<template>
  <form :action="filesaver.url + '?access_token=' + access_token" method="post" target="_blank">
    <input type="hidden" v-for="(key, value) in filesaver.props" :name="key" :value="value">
    <!-- <input type="hidden" name="Id" :value="filesaver.props"> -->
  </form>
</template>

<script>
export default {
  vuex: {
    getters: {
      access_token: state => state.access_token,
      filesaver: state => state.filesaver
    }
  },
  watch: {
    "filesaver.props": function (value) {
      this.$el.submit();
    }
  }
};
</script>


// WEBPACK FOOTER //
// FileSaver.vue?45986392